<template>
<div class="chapter">
<div class="inner_page">
<div class="fm">
<p class="extract"><b>BOOK I</b></p>
<p class="extract3">Cast of Characters</p>
<p class="extract2">Wilhelm Krause: a Nazi general</p>
<p class="extract2">Rolf Hermann:Kapitänleutnant of the Nazi submarine <i>U-127</i></p>
<p class="extract2">Helmut Meier: SS major and Krause’s right-hand man</p>
<p class="extract2">Franz Mueller:minister of foreign procurement for the Nazis</p>
<p class="extract2">Ricardo Von Bruhl: an old friend of Krause and president of Banco Nationale de</p>
<p class="extract3">Buenos Aires</p>
<p class="extract2">Jacques Mollard: an innkeeper in Peillon</p>
<p class="extract2">Evelina Panelli: a young field worker in Peillon</p>
<p class="extract2">Nadia Panelli: her twin sister</p>
<p class="extract2">Johann Brandt: a top Nazi agent</p>
<p class="extract2">Eduardo Diaz: an old friend of Krause</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p01.vue?db818062